<template>
  <pa-header></pa-header>
  <div class="text-center flex items-center justify-center py-40" v-if="loading">
    <div class="lds-ripple">
      <div></div>
    </div>
    Loading please wait...
  </div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-4 mb-10" v-for="(v,index) in contacts" v-bind:key="index">
        <div class="rounded  p-8 " style="background : #fff;">
          <h2 class="text-3xl font-bold " style="font-family: 'Roboto Condensed'">{{ v.title }}</h2>
          <small>{{ v.address }}</small>
          <div class="mt-3 fw-bold text-danger">Email : {{ v.email }}</div>
          <div class="text-secondary fw-bold">Phone : {{ v.phone }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import PaHeader from "@/views/Pa-Header";

var SpatialNavigation = window.SpatialNavigation;

export default {
  components: {PaHeader},
  data() {
    return {
      contacts: [],
      loading: false
    }
  },
  mounted() {
    var el = document.querySelectorAll('.router-link-exact-active')[0];
    if (el) el.classList.add('active');
    SpatialNavigation.focus('.router-link-exact-active');
    this.loading = true;
    axios.get('http://tv.primeasianews.com/api/contacts.php')
        .finally(() => {
          this.loading = false;
        })
        .then(res => {
          this.contacts = res.data
        });
  }
}
</script>
